import React, { useEffect, useMemo, useState } from 'react';

import { RadioOrSelectOption } from '../../../../../../types/common.types';
import { Member, TeamMember } from '../../../../../../types/entity.types';

import Button from '../../../../../common/button/Button';
import Dropdown from '../../../../../common/input/dropdown/Dropdown';
import Modal from '../../../../../common/modal/Modal';

import '../team-modals.scss';

type Props = {
  show: boolean;
  close: () => void;
  members: Member[];
  teamMembers?: TeamMember[];
  addMemberToTeam: (memberExternalReference: string, close: () => void) => void;
};

const AddTeamMemberModal = ({ show, close, members, teamMembers, addMemberToTeam }: Props) => {
  const [selectedMemberOption, setSelectedMemberOption] = useState<RadioOrSelectOption | undefined>();

  useEffect(() => {
    if (!show) {
      setSelectedMemberOption(undefined);
    }
  }, [show]);

  const sortedMemberOptions = useMemo(() => {
    const teamMemberReferences = new Set(
      teamMembers?.map((teamMember) => teamMember.memberExternalReference).filter(Boolean)
    );

    const sortedMembers = [...members].sort((memberOne, memberTwo) => {
      if (!memberOne.name || !memberTwo.name) return 0;
      if (memberOne.name > memberTwo.name) return 1;
      if (memberOne.name < memberTwo.name) return -1;

      return 0;
    });
    const filteredMembers = sortedMembers.filter((member) => !teamMemberReferences.has(member.externalReference));

    return filteredMembers.map((member) => ({
      label: `${member.firstName} ${member.lastName}`,
      value: member.externalReference!
    }));
  }, [members, teamMembers]);

  const handleButtonClick = () => {
    if (!selectedMemberOption) return;
    addMemberToTeam(selectedMemberOption.value, close);
  };

  if (!show) return <></>;

  return (
    <Modal show={show}>
      <section className="team-modals">
        <h1 className="team-modals__header">Add Member</h1>
        <section className="add-team-member-modal__member-dropdown-container">
          <label className="add-team-member-modal__member-dropdown-label" htmlFor="members">
            Member:
          </label>
          <div className="add-team-member-modal__member-dropdown">
            <Dropdown
              name="members"
              value={selectedMemberOption}
              options={sortedMemberOptions}
              onChange={setSelectedMemberOption}
            />
          </div>
        </section>
        <section className="team-modals__button-container">
          <Button text="Cancel" onClick={close} />
          <Button text="Save" onClick={handleButtonClick} disabled={!selectedMemberOption} />
        </section>
      </section>
    </Modal>
  );
};

export default AddTeamMemberModal;
